import React from 'react';
import { ArrowRight, FileCheck } from 'lucide-react';
import { Button } from './ui/button';

const CTABanner = ({ variant = 'default' }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (variant === 'compact') {
    return (
      <div className="text-center py-8">
        <Button
          onClick={scrollToContact}
          size="lg"
          className="bg-[#FFDA0C] hover:bg-[#E5C500] text-[#082E5C] font-bold text-lg px-10 py-6 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl group"
        >
          Solicita tu Diagnóstico Gratuito
          <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-[#00D4D8] to-[#082E5C] rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl transform hover:scale-[1.02] transition-all duration-300">
      <div className="flex justify-center mb-6">
        <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
          <FileCheck className="text-white" size={40} />
        </div>
      </div>
      <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
        ¿Listo para la Transformación Digital?
      </h3>
      <p className="text-lg md:text-xl text-gray-100 mb-8 max-w-2xl mx-auto px-4">
        Obtén un diagnóstico gratuito de tu propiedad y descubre cómo podemos optimizar tu administración
      </p>
      <div className="flex justify-center px-4">
        <Button
          onClick={scrollToContact}
          size="lg"
          className="bg-[#FFDA0C] hover:bg-[#E5C500] text-[#082E5C] font-bold text-sm md:text-xl px-6 md:px-12 py-6 md:py-7 rounded-xl transition-all duration-300 hover:scale-110 hover:shadow-2xl group w-full md:w-auto"
        >
          <span className="block md:hidden">Solicitar Diagnóstico Gratuito</span>
          <span className="hidden md:block">Solicitar Diagnóstico Gratuito Ahora</span>
          <ArrowRight className="ml-2 md:ml-3 group-hover:translate-x-2 transition-transform flex-shrink-0" size={20} />
        </Button>
      </div>
    </div>
  );
};

export default CTABanner;